const sifa = {
  C003TiposDeActoReclamado: 'SIFA/Catalogos/GetTiposDeActoReclamado',
  C005TiposDeCalificacion: 'SIFA/Catalogos/GetTiposDeCalificacion',
  C004TiposDeEstadoDeAdmision: 'SIFA/Catalogos/GetTiposDeEstadoDeAdmision',
  C011Adscripciones: 'SIFA/Catalogos/GetAdscripciones'
};

export default sifa;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIFA/catalogos/sifa.js
// module id = null
// module chunks = 